import React from 'react';
import { Container, Row, Col, Form, Spinner } from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';
import { withAuthorization } from '../Session';
class ViewProfile extends React.Component {
    _isMounted = false;
    state = {
        alert: 0,
        alertMessage: '',
        flag: true,
        showAddEdit: true,
        FullName: '',
        DateOfBirth: '',
        EmailId: '',
        RegionalLanguage: '',
        PhoneNumber: '',
        SecondaryPhoneNumber: '',
        WhatsAppNumber: '',
        Education: '',
        Profession: '',
        PanNumber: '',
        AadharNumber: '',
        BankName: '',
        AccountNumber: '',
        AccountHolderName: '',
        IFSCCode: '',
        AccountType: '',
        HouseNumber: '',
        Area: '',
        City: '',
        District: '',
        PinCode: '',
        State: '',
        LastUpdatedTimeStamp: '',
        UpdatedBy: '',
        RequestedTimeStamp: '',
        profileDocId: '',
        AllRegionalLanguage: [
            'Bengali',
            'English',
            'Gujarati',
            'Hindi',
            'Kannada',
            'Malayalam',
            'Marathi',
            'Oriya',
            'Punjabi',
            'Telugu'
        ],
        AllProfessions: [
            'CSC Center',
            'Money Transfer Point',
            'Fancy Shop',
            'Super Market',
            'Electronics Store',
            'Home Appliances Store',
            'Clothes Store',
            'Xerox Store',
            'Others'
        ],
        AllStates: [
            'Andhra Pradesh',
            'Arunachal Pradesh',
            'Assam',
            'Bihar',
            'Chhattisgarh',
            'Goa',
            'Gujarat',
            'Haryana',
            'Himachal Pradesh',
            'Jammu & Kashmir',
            'Jharkhand',
            'Karnataka',
            'Kerala',
            'Madhya Pradesh',
            'Maharashtra',
            'Manipur',
            'Meghalaya',
            'Mizoram',
            'Nagaland',
            'Odisha',
            'Punjab',
            'Rajasthan',
            'Sikkim',
            'TamilNadu',
            'Telangana',
            'Tripura',
            'Uttarakhand',
            'Uttar Pradesh',
            'West Bengal'
        ]
    };

    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        this._isMounted = true;
        this.getProfileDetail();
    }

    async getProfileDetail() {
        if (this._isMounted) {
            this.setState({ flag: false });
        }
        let dataRow = {
            UniqeID: this.props.user.ProfileUniqeID
        };

        await RestServices.getProfileDetail(
            localStorage.getItem('FirebaseToken'),
            dataRow
        )
            .then((response) => response.json())
            .then((responseData) => {
                
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            flag: false,
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    if (responseData) {
                        if (this._isMounted) {
                            this.setState({ flag: false });
                            this.setState({
                                ...this.fieldsMapUtil(responseData)
                            });
                        }
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        flag: false,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }

    onChangeValues = (event) => {
        if (event.target.value === '')
            if (this._isMounted) {
                this.setState({ [event.target.name]: '' });
            } else {
                if (this._isMounted) {
                    this.setState({ [event.target.name]: event.target.value });
                }
            }
    };

    fieldsMapUtil = (data) => {
        let res = {};
        Object.keys(data).forEach((val) => {
            res = { ...res, [val]: data[val] };
        });
        res = {
            ...res,
            oldAccountNumber: data.AccountNumber,
            oldAccountHolderName: data.AccountHolderName,
            oldBankName: data.BankName,
            oldIFSCCode: data.IFSCCode,
            oldPanNumber: data.PanNumber,
            oldPhoneNumber: data.PhoneNumber,
            LastUpdatedTimeStamp: data.LastUpdatedTimeStamp,
            UpdatedBy: data.UpdatedBy,
            RequestedTimeStamp: data.RequestedTimeStamp
        };
        return res;
    };

    render() {
        return (
            <Container className="no_padding">
                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                {this.state.flag && <Spinner animation="border" />}

                <Row>
                    <Col>
                        <h5>Personal Details</h5>
                        <hr />
                    </Col>
                </Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Full Name</Form.Label>
                        <Form.Control
                            disabled
                            type="text"
                            name="FullName"
                            value={this.state.FullName}
                            onChange={this.onChangeValues}
                            required
                        />
                    </Form.Group>
                </Form.Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Date of Birth</Form.Label>
                        <Form.Control
                            disabled
                            type="date"
                            name="DateOfBirth"
                            value={this.state.DateOfBirth}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Email Id</Form.Label>
                        <Form.Control
                            disabled
                            type="text"
                            name="EmailId"
                            value={this.state.EmailId}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Regional Language</Form.Label>
                        <Form.Control
                            disabled
                            type="text"
                            name="RegionalLanguage"
                            value={this.state.RegionalLanguage}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Education</Form.Label>
                        <Form.Control
                            disabled
                            type="text"
                            name="Education"
                            value={this.state.Education}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Mobile Number</Form.Label>
                        <Form.Control
                            disabled
                            type="text"
                            name="PhoneNumber"
                            value={this.state.PhoneNumber}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Alternate Mobile Number</Form.Label>
                        <Form.Control
                            disabled
                            type="text"
                            name="SecondaryPhoneNumber"
                            value={this.state.SecondaryPhoneNumber}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>WhatsApp Number</Form.Label>
                        <Form.Control
                            disabled
                            type="text"
                            name="WhatsAppNumber"
                            value={this.state.WhatsAppNumber}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Profession</Form.Label>
                        <Form.Control
                            disabled
                            type="text"
                            name="Profession"
                            value={this.state.Profession}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>

                <Row>
                    <Col>
                        <h5>Residential Address</h5>
                        <hr />
                    </Col>
                </Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>House Number</Form.Label>
                        <Form.Control
                            disabled
                            type="text"
                            name="HouseNumber"
                            value={this.state.HouseNumber}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Area</Form.Label>
                        <Form.Control
                            disabled
                            type="text"
                            name="Area"
                            value={this.state.Area}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>City/Town</Form.Label>
                        <Form.Control
                            disabled
                            type="text"
                            name="City"
                            value={this.state.City}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Pincode</Form.Label>
                        <Form.Control
                            disabled
                            type="text"
                            name="PinCode"
                            value={this.state.PinCode}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>District</Form.Label>
                        <Form.Control
                            disabled
                            type="text"
                            name="District"
                            value={this.state.District}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>State</Form.Label>
                        <Form.Control
                            disabled
                            type="text"
                            name="State"
                            value={this.state.State}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Row>
                    <Col>
                        <h5>Banking Details</h5>
                        <hr />
                    </Col>
                </Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>PAN Number</Form.Label>
                        <Form.Control
                            disabled
                            type="text"
                            name="PanNumber"
                            value={this.state.PanNumber}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Aadhar Number</Form.Label>
                        <Form.Control
                            disabled
                            type="text"
                            name="AadharNumber"
                            value={this.state.AadharNumber}
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Account Holder Name</Form.Label>
                        <Form.Control
                            disabled
                            value={this.state.AccountHolderName}
                            name="AccountHolderName"
                            type="text"
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Bank Name</Form.Label>
                        <Form.Control
                            disabled
                            value={this.state.BankName}
                            name="BankName"
                            type="text"
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Account Number</Form.Label>
                        <Form.Control
                            disabled
                            value={this.state.AccountNumber}
                            name="AccountNumber"
                            type="text"
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>IFSC Code</Form.Label>
                        <Form.Control
                            disabled
                            value={this.state.IFSCCode}
                            name="IFSCCode"
                            type="text"
                            onChange={this.onChangeValues}
                        />
                    </Form.Group>
                </Form.Row>
                <hr />
            </Container>
        );
    }
}

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(ViewProfile);
